<template>
  <div class="md:ml-12 max-w-600 my-8 mb-12">
    <div class="label">
      <img src="./assets/shortAnswer.svg" alt="选择题" />
      <span class="px-2">简答题</span>
    </div>
    <div class="short-wrapper">
      <div>
        <h1 class="title-text">
          <span>{{ content.title.trim() }}</span>
          <!-- 分数配置 -->
          <span v-if="content.score">({{ content.score }}分)</span>
        </h1>
      </div>

      <div ref="textWrapper" class="relative w-full min-h-48 max-h-120">
        <div class="text max-h-120 relative" style="z-index: -1">
          {{ disabled ? content.text : text }}
        </div>
        <textarea
          v-if="disabled"
          ref="textarea"
          v-model.trim="content.text"
          :disabled="disabled"
          class="textarea"
        ></textarea>
        <textarea
          v-else
          ref="textarea"
          v-model.trim="text"
          :disabled="disabled"
          :placeholder="content.placeholder || '在此处输入答案哦'"
          class="textarea"
        ></textarea>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <button
        v-if="!content.text"
        class="block w-full px-4 py-2 mt-6 rounded-md cursor-pointer border border-primar bg-motif hover:opacity-hover active:opacity-active text-white"
        @click="handleSubmit"
      >
        确定
      </button>
      <div
        v-if="content.text && (content.answer || content.analysis)"
        class="answer px-4 py-2 mt-6 rounded-md font-medium border border-gray-300 bg-white"
      >
        <div class="answer-label">解析</div>
        <hr class="my-3" />
        <div class="answer">
          <span>正确答案:</span>
          <span v-for="answer in content.answer" :key="answer" class="ml-2">{{ answer }}</span>
        </div>
        <div class="analysis">
          {{ content.analysis }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';
import { namespace } from 'vuex-class';
import { Score } from '@/store/modules/common/types';

const userModule = namespace('common');

export type Scoring = 'start' | 'end' | '开始' | '结束';

@Component({
  name: 'ShortAnswer'
})
export default class ShortAnswer extends Vue {
  @Prop({ type: Object }) content!: Content & {
    title: string;
    text: string;
    score: number;
    startTime: number;
    template?: string;
    placeholder?: string;
    reviewMark?: string;
  };
  @userModule.State('score') score!: Score;

  text = '';
  // px
  bufferHeight = 32;

  get disabled() {
    return !!this.content.text;
  }

  mounted() {
    if (!this.text) this.text = this.content.template || '';
  }

  handleSubmit() {
    if (this.text.length === 0 || (this.content.template && this.text === this.content.template)) {
      this.$Message.info({
        time: 1500,
        content: '要先回答才能继续哦'
      });
      return;
    }
    this.$emit('submit', {
      score: this.score.type === 'multiple' ? 0 : this.content.score || 0,
      totalScore: this.content.score || 0,
      duration: new Date().getTime() - (this.content.startTime || 0)
    });
    window.storyteller.updateAssignContent({
      $id: this.content.$id,
      $kind: this.content.$kind,
      ...{
        text: this.text,
        duration: new Date().getTime() - (this.content.startTime || 0),
        selection_id: this.score.selection_id
      }
    });
    this.saveReviewData();
  }

  saveReviewData() {
    if (!this.content.reviewMark) return;
    this.$store.dispatch('survey/setData', {
      contentId: this.content.$id.split('#')[0],
      mark: this.content.reviewMark,
      content: this.getValue()
    });
  }

  getValue() {
    return {
      type: 'text',
      title: this.content.title,
      content: {
        title: this.content.title,
        text: this.text
      }
    };
  }
}
</script>

<style scoped>
.title-text {
  @apply w-full flex items-center text-lg whitespace-pre-wrap;
  padding: 10px;
  color: #1a051d;
  border-bottom: 1px solid #d3d3d3;
}
.label {
  @apply mb-4 flex text-motif-500;
}

.short-wrapper {
  @apply rounded-lg;
  border: 1px solid #d3d3d3;
}

.text {
  @apply text-base py-8 min-h-48;
  color: transparent;
  line-height: 1.75rem;
  white-space: pre-wrap;
}

.textarea {
  @apply absolute top-0 left-0 w-full rounded-md ring-0 h-full border-none resize-none text-base;
  line-height: 1.75rem;
  border-color: #d0d0d6;
  outline: none !important;
}

textarea:focus {
  background-color: #f7f7f7;
  border-color: #9e82ec;
}

.answer-label {
  @apply font-medium text-lg;
  color: rgba(64, 71, 245, 0.8);
}

.answer {
  @apply mb-3 font-medium text-lg;
  color: #272564;
}

.analysis {
  @apply font-normal;
  color: #333333;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
